import { Container, Divider, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import { benefitListData } from '@/constants/Srp'

import BenefitListIcon from './BenefitListIcon'

const BenefitList = ({isIntl = false, isVisaAvailable = false}: {isIntl?: boolean; isVisaAvailable?: boolean}) => {
    return benefitListData.map((benefit, index) => {
        const { benefitDisplayName, benefitKey } = benefit
        const showDivider = isIntl ? (index < benefitListData.length - 1) :  (index < benefitListData.length - 2)
        if(benefitKey === 'VISA_REJECTION_COVER' && (!isIntl || !isVisaAvailable)) return null
        return (
            <>
                <Container className={`flex flex-middle py-3 ff-row-${benefitKey}`}>
                    <BenefitListIcon benefitKey={benefitKey} />
                    <Typography className="pl-2" variant="L3">
                        {benefitDisplayName}
                    </Typography>
                </Container>
                {showDivider && <Divider borderColor="#E6E6E6" borderStyle="dashed" />}
            </>
        )
    })
}

export default BenefitList
